import auth from "./authenticationStore";
import app from "./applicationStore";
import admin from "./adminStore";
import vehicle from "./vehicleStore";

export default {
  app,
  auth,
  admin,
  vehicle,
};
